module.exports = __webpack_public_path__ + "media/images/shared/branches_map/geo-aab29d25bf4b4522dea5f5d67f522f95.svg";